const moduleRoot = `/search`;

export const PATHS = {
    SEARCH: {
        path: `${moduleRoot}`,
    },
};
